import { render, staticRenderFns } from "./HeaderPostmatchGame.vue?vue&type=template&id=58e100a6&scoped=true&"
import script from "./HeaderPostmatchGame.vue?vue&type=script&lang=js&"
export * from "./HeaderPostmatchGame.vue?vue&type=script&lang=js&"
import style1 from "./HeaderPostmatchGame.vue?vue&type=style&index=1&id=58e100a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e100a6",
  null
  
)

export default component.exports